import { API_NEWS_TICKER_URL } from "src/constants/urls";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { IUser } from "src/types/common";

export interface INewsTickerItem {
    url: string;
    title: string;
    trader?: Pick<IUser, "firstName" | "lastName" | "isDeleted" | "nickName" | "id">;
    interaction?: string;
}

export type TNewsTickerResponse = INewsTickerItem[];

export const useNewsTickerQuery = () => useQuery<TNewsTickerResponse>({ url: API_NEWS_TICKER_URL });
